<template>
  <div>
    <alert
      v-if="chosenVariant && variantDetails.count_on_hand === 0"
      variant="danger"
      class="mb-1 text-sm font-weight-bold text-center"
    >
      {{ missingCountOnHandText }}
    </alert>
    <alert
      v-if="chosenVariant && (variantDetails.count_on_hand > 0 && variantDetails.count_on_hand < 3)"
      variant="warning"
      class="mb-1 text-sm text-center"
    >
      {{ lowCountOnHandText }}
    </alert>
  </div>
</template>

<script>
import Alert from "./Alert";
import { mapGetters } from "vuex";

export default {
  name: "VariantPicker",
  components: {
    Alert,
  },
  props: {
    missingCountOnHandText: {
      required: true,
      type: String,
    },
    lowCountOnHandText: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
      variants: "variantPicker/allProductVariants",
    }),
    variantDetails() {
      return this.variants.find(variant => variant.id === this.chosenVariant);
    },
  },
};
</script>
